import {HomeComponent} from '~/app/web/home/home.component';
import {MenuComponent} from '~/app/web/webcomponents/menu/menu.component';
import {AppComponent} from '~/app/app.component';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from '~/app/app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {DateInputsModule} from '@progress/kendo-angular-dateinputs';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {DialogsModule} from '@progress/kendo-angular-dialog';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {MenuModule} from '@progress/kendo-angular-menu';
import {KeycloakAngularModule} from 'keycloak-angular';
import {HttpClientModule} from '@angular/common/http';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {PopupModule} from '@progress/kendo-angular-popup';
// @ts-ignore
import {MclaneWebauthLibModule} from 'mclane-webauth-lib';
import {PageNotFoundComponent} from '~/app/web/common/page-not-found/page-not-found.component';


export const MODULESWEB: any[] = [
   BrowserModule,
   AppRoutingModule,
   BrowserAnimationsModule,
   ButtonsModule,
   DateInputsModule,
   DropDownsModule,
   DialogsModule,
   LayoutModule,
   MenuModule,
   KeycloakAngularModule,
   HttpClientModule,
   InputsModule,
   PopupModule,
   MclaneWebauthLibModule,
];

export const COMPONENT_DECLARATIONSWEB: any[] = [
   AppComponent,
   HomeComponent,
   MenuComponent,
   PageNotFoundComponent
];

export const PROVIDERSWEB: any[] = [

];
